
import React from "react"
import { FormulaElement, MediaElement, CheckElement, DateTimeElement, DurationElement, ElementBase, GeoElement, MultipleElement, NumberElement, QrElement, TextElement, TimestampElement, TitleElement, GroupElement, SimpleListElement, PopulateElement, SignatureElement, ValidateElement } from "."
import { VStack, FlatList, HStack } from "@gluestack-ui/themed";
import { View } from "react-native";
export const FieldsList = ({ horizonalView, scroll, itemsStore, fields, parentId = undefined, forReview = false, recordIdx = undefined, statusStore,setItemRef }) => {
    console.log("FieldsList", "parentId", parentId)
    forReview = forReview == true;

    const putFields = (fields: any[], parentId: string = undefined, recordIdx = undefined) => {
        const payload = itemsStore.itemActive.payload;
        return fields?.map((field: any, idx: number) => {
            if (!forReview
                || field.type == 'checkbox' || field.type == 'group' || field.type == 'simplelist' || field.type == 'title'
                || (payload.get(field.id) && JSON.stringify(payload.get(field.id).value) != "" && payload.get(field.id).value != null)) {
                if (field.isArchived)
                    return (null);
                let fieldType = field.type == "sendemail" ? (field.templateData.asSelect ? "select" : "text") : field.type;
                let obj = <></>;
                switch (fieldType) {
                    case 'time':
                    case 'date':
                        obj = <DateTimeElement parentId={parentId} element={field} key={"DateTimeElement".concat(field.id)} forReview={forReview} recordIdx={recordIdx} />
                        break;
                    case 'duration':
                        obj = <DurationElement parentId={parentId} element={field} key={"DateTimeElement".concat(field.id)} forReview={forReview} recordIdx={recordIdx} />
                        break;
                    case 'checkbox':
                        obj = <CheckElement setItemRef={setItemRef} parentId={parentId} element={field} key={"CheckElement".concat(field.id)} forReview={forReview} recordIdx={recordIdx} />
                        break;
                    case 'select':
                    case 'multiple':
                        obj = <MultipleElement parentId={parentId} element={field} key={"MultipleElement".concat(field.id)} forReview={forReview} recordIdx={recordIdx} />
                        break;
                    case 'timestamp':
                        obj = <TimestampElement parentId={parentId} element={field} key={"TimestampElement".concat(field.id)} forReview={forReview} recordIdx={recordIdx} />
                        break;
                    case 'geo':
                        obj = <GeoElement parentId={parentId} element={field} key={"GeoElement".concat(field.id)} forReview={forReview} recordIdx={recordIdx} />
                        break;
                    case 'text':
                        obj = <TextElement parentId={parentId} element={field} key={"TextElement".concat(field.id)} forReview={forReview} recordIdx={recordIdx} />
                        break;
                    case 'qr':
                        obj = <QrElement parentId={parentId} element={field} key={"TextElement".concat(field.id)} forReview={forReview} recordIdx={recordIdx} />
                        break;
                    case 'docs':
                    case 'video':
                    case 'photo':
                        obj = <MediaElement parentId={parentId} element={field} key={"MediaElement".concat(field.id)} forReview={forReview} recordIdx={recordIdx} />
                        break;
                    case 'number':
                        obj = <NumberElement parentId={parentId} element={field} key={"NumberElement".concat(field.id)} forReview={forReview} recordIdx={recordIdx} />
                        break;
                    case 'formula':
                        obj = <FormulaElement parentId={parentId} element={field} key={"FormulaElement".concat(field.id)} forReview={forReview} recordIdx={recordIdx} />
                        break;
                    case 'group':
                        obj = field.nodes?.length > 0 ? (<GroupElement parentId={parentId} element={field} key={"GroupElement".concat(field.id)} forReview={forReview} recordIdx={recordIdx} >
                            {
                                putFields(field.nodes, parentId, recordIdx)
                            }
                        </GroupElement>) : <></>;
                        break;
                    case 'simplelist':
                        let autonumeric= field.nodes.find(f=>f.type=="autonumeric");
                    if(autonumeric!=undefined){
                        autonumeric.type= "formula";
                        autonumeric.templateData.hidden= false;
                        autonumeric.templateData.formula = {formula: "i", variables:[{variable:"i", dataSource:{id:"{index}"}}]}
                    }
                        obj = field.nodes?.length > 0 ? (<SimpleListElement parentId={parentId} element={field} key={"SimpleListElement".concat(field.id)} forReview={forReview} recordIdx={recordIdx}>
                            <View style={{
                                flexDirection: 'row',
                                flexWrap: 'wrap', // Esto hace el "wrap" al llegar al final
                                padding: 2, width: "100%", marginTop: "auto"
                            }} >{
                                putFields(field.nodes, field.id, recordIdx)
                            }</View>
                        </SimpleListElement>) : <></>;
                        break;
                    case 'title':
                        obj = <TitleElement parentId={parentId} element={field} key={"TitleElement".concat(field.id)} recordIdx={recordIdx} />
                        break;
                    case 'populate':
                        obj = <PopulateElement parentId={parentId} element={field} key={"PopulateElement".concat(field.id)} forReview={forReview} recordIdx={recordIdx} />
                        break;
                    case 'validate':
                        obj = <ValidateElement parentId={parentId} element={field} key={"ValidateElement".concat(field.id)} forReview={forReview} recordIdx={recordIdx} />
                        break;
                    case 'sign':
                        obj = <SignatureElement parentId={parentId} element={field} key={"SignatureElement".concat(field.id)} forReview={forReview} recordIdx={recordIdx} />
                        break;
                    default:
                        obj = <ElementBase errors={[]} element={field} key={"ElementBase".concat(field.id)} recordIdx={recordIdx} />
                }
                let width = "100%"           
                if (field.templateData?.width && statusStore.windowDimensions.width>600){
                    width = field.templateData.width;                   
                }
                    
                return <View key={"view_fld_".concat(field.id)} style={{ minWidth: 50, borderTopWidth: fieldType=="group"?0:1, borderTopColor: "#ccc", width: width, flexWrap: "wrap" }} backgroundColor={field.templateData?.backgroundColor || "#fff"}>{obj}</View>;
                
            }
            return null;

        });
    }

    const putField = (field: any, parentId: string = undefined, recordIdx = undefined) => {
        const payload = itemsStore.itemActive.payload;
        if (!forReview
            || field.type == 'checkbox' || field.type == 'group' || field.type == 'simplelist' || field.type == 'title'
            || (payload.get(field.id) && JSON.stringify(payload.get(field.id).value) != "" && payload.get(field.id).value != null)) {
            if (field.isArchived)
                return (null);
            let fieldType = field.type == "sendemail" ? (field.templateData.asSelect ? "select" : "text") : field.type;
            switch (fieldType) {
                case 'time':
                case 'date':
                    return <DateTimeElement parentId={parentId} element={field} key={"DateTimeElement".concat(field.id)} forReview={forReview} recordIdx={recordIdx} />
                case 'duration':
                    return <DurationElement parentId={parentId} element={field} key={"DateTimeElement".concat(field.id)} forReview={forReview} recordIdx={recordIdx} />
                case 'checkbox':
                    return <CheckElement parentId={parentId} element={field} key={"CheckElement".concat(field.id)} forReview={forReview} recordIdx={recordIdx} />
                case 'select':
                case 'multiple':
                    return <MultipleElement parentId={parentId} element={field} key={"MultipleElement".concat(field.id)} forReview={forReview} recordIdx={recordIdx} />
                case 'timestamp':
                    return <TimestampElement parentId={parentId} element={field} key={"TimestampElement".concat(field.id)} forReview={forReview} recordIdx={recordIdx} />
                case 'geo':
                    return <GeoElement parentId={parentId} element={field} key={"GeoElement".concat(field.id)} forReview={forReview} recordIdx={recordIdx} />
                case 'text':
                    return <TextElement parentId={parentId} element={field} key={"TextElement".concat(field.id)} forReview={forReview} recordIdx={recordIdx} />
                case 'qr':
                    return <QrElement parentId={parentId} element={field} key={"TextElement".concat(field.id)} forReview={forReview} recordIdx={recordIdx} />
                case 'docs':
                case 'video':
                case 'photo':
                    return <MediaElement parentId={parentId} element={field} key={"MediaElement".concat(field.id)} forReview={forReview} recordIdx={recordIdx} />
                case 'number':
                    return <NumberElement parentId={parentId} element={field} key={"NumberElement".concat(field.id)} forReview={forReview} recordIdx={recordIdx} />
                case 'formula':
                    return <FormulaElement parentId={parentId} element={field} key={"FormulaElement".concat(field.id)} forReview={forReview} recordIdx={recordIdx} />
                case 'group':
                    return field.nodes?.length > 0 ? (<GroupElement parentId={parentId} element={field} key={"GroupElement".concat(field.id)} forReview={forReview} recordIdx={recordIdx} >
                        <View style={{
                            flexDirection: 'row',
                            flexWrap: 'wrap', // Esto hace el "wrap" al llegar al final
                            padding: 2, width: "100%", marginTop: "auto"
                        }} >{
                                putFields(field.nodes, field.id, recordIdx)
                            }</View>
                    </GroupElement>) : null;
                case 'simplelist':
                    return field.nodes?.length > 0 ? (<SimpleListElement parentId={parentId} element={field} key={"SimpleListElement".concat(field.id)} forReview={forReview} recordIdx={recordIdx}>
                        <View style={{
                            flexDirection: 'row',
                            flexWrap: 'wrap', // Esto hace el "wrap" al llegar al final
                            padding: 2, width: "100%", marginTop: "auto"
                        }} >{
                                putFields(field.nodes, field.id, recordIdx)
                            }</View>
                    </SimpleListElement>) : null;
                case 'title':
                    return <TitleElement parentId={parentId} element={field} key={"TitleElement".concat(field.id)} recordIdx={recordIdx} />
                case 'populate':
                    return <PopulateElement parentId={parentId} element={field} key={"PopulateElement".concat(field.id)} forReview={forReview} recordIdx={recordIdx} />
                case 'validate':
                    return <ValidateElement parentId={parentId} element={field} key={"ValidateElement".concat(field.id)} forReview={forReview} recordIdx={recordIdx} />
                case 'sign':
                    return <SignatureElement parentId={parentId} element={field} key={"SignatureElement".concat(field.id)} forReview={forReview} recordIdx={recordIdx} />
                default:
                    return <ElementBase errors={[]} element={field} key={"ElementBase".concat(field.id)} recordIdx={recordIdx} />
            }
        }
        return null;
    }


    if (scroll)
        return <View style={{
            flexDirection: 'row',
            flexWrap: 'wrap', // Esto hace el "wrap" al llegar al final
            padding: 2, width: "100%", marginTop: "auto"
        }} >{putFields(fields, parentId, recordIdx)}</View>;

    /* if (scroll)
        return <VStack width={"$full"}>{putFields(fields, parentId, recordIdx)}</VStack>;
 */
    return <><FlatList data={fields}
        renderItem={({ item }) => putField(item, parentId, recordIdx)}
        keyExtractor={item => item.id}
    ></FlatList>
    </>
}